import api from "@/api";

export const definicoesService = {
  async get() {
    const { data } = await api.get("/definicoes");
    return data;
  },

  async update(payload) {
    const { data } = await api.put("/definicoes", payload);
    return data;
  },

  // ── Refeições ──
  async getRefeicoes() {
    const { data } = await api.get("/definicoes/refeicoes");
    return data;
  },

  async updateRefeicoes(refeicoes) {
    const { data } = await api.put("/definicoes/refeicoes", { refeicoes });
    return data;
  },

  async deleteRefeicao(optKey) {
    const { data } = await api.delete(`/definicoes/refeicoes/${optKey}`);
    return data;
  },

  // ── Categorias de produto ──
  async getCategorias() {
    const { data } = await api.get("/definicoes/produtos-categorias");
    return data;
  },

  async renomearCategoria(payload) {
    const { data } = await api.post(
      "/definicoes/produtos/renomear-categoria",
      payload
    );
    return data;
  },

  async removerCategoria(payload) {
    const { data } = await api.post(
      "/definicoes/produtos/remover-categoria",
      payload
    );
    return data;
  },

  async categorizarProdutos(payload) {
    const { data } = await api.post(
      "/definicoes/produtos/categorizar",
      payload
    );
    return data;
  },
};
